import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

/**
 * ProtectedRoute — wraps a page to require authentication.
 * Optionally checks for a specific permission (menuKey).
 */
export default function ProtectedRoute({ children, menuKey, requiredRole }) {
    const { isAuthenticated, loading, hasPermission, user } = useAuth();

    // Show nothing while checking auth state
    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[60vh]">
                <div className="flex flex-col items-center gap-3">
                    <div className="w-10 h-10 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
                    <span className="text-sm text-slate-500">Checking authentication...</span>
                </div>
            </div>
        );
    }

    // Not authenticated — redirect to login
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Check required role
    if (requiredRole && user?.role !== requiredRole && user?.role !== 'super_admin') {
        return (
            <div className="flex items-center justify-center min-h-[60vh]">
                <div className="text-center">
                    <h2 className="text-2xl font-bold text-slate-900 mb-2">Access Denied</h2>
                    <p className="text-slate-500">You don't have permission to access this page.</p>
                </div>
            </div>
        );
    }

    // Check menu permission
    if (menuKey && !hasPermission(menuKey)) {
        return (
            <div className="flex items-center justify-center min-h-[60vh]">
                <div className="text-center">
                    <h2 className="text-2xl font-bold text-slate-900 mb-2">Access Denied</h2>
                    <p className="text-slate-500">You don't have permission to access this feature.</p>
                </div>
            </div>
        );
    }

    return children;
}
